import { makeStyles } from '@material-ui/core/styles';

// Same centered column as the Sweep Account page.
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: 720,
    margin: '0 auto',
    padding: theme.spacing(8, 0)
  },
  title: {
    justifyContent: 'center'
  },
  subtitle: {
    justifyContent: 'center',
    marginBottom: theme.spacing(4)
  },
  poc: {
    padding: theme.spacing(4, 6)
  },
  // Drop the Switch's form-row min height so the description sits right under the name
  pocSwitch: {
    minHeight: 0
  },
  description: {
    display: 'block',
    // Lines up with the name: the switch takes 44px of the row once FormControlLabel's -11px margin applies
    paddingLeft: 44
  }
}));

export default useStyles;
